export default __webpack_public_path__ + "static/media/tips-person.4830f99d.png";